import { Button, Dialog, DialogContent, Typography } from '@mui/material';

import kebabCase from 'lodash/kebabCase';

import DialogTitleWithX from '@/components/DialogTitleWithX';
import { DialogProps } from '@toolpad/core/useDialogs';

import { DialogActions } from '../styled';
import { ConfirmationDialogPayload } from './types';

function ConfirmationDialog({
  payload: {
    title,
    prompt,
    dialogId = kebabCase(title),
    okText = 'Confirm',
    okColor = 'error',
    cancelText = 'Cancel',
    autoFocus = true,
    width = 500,
  },
  onClose,
  open,
}: DialogProps<ConfirmationDialogPayload, boolean>) {
  function handleClose(confirmed: boolean) {
    onClose(confirmed);
  }

  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby={`${dialogId}-title`}
      aria-describedby={`${dialogId}-description`}
      slotProps={{
        paper: {
          sx: { width, maxWidth: 800 },
        },
      }}
    >
      <DialogTitleWithX onClose={() => handleClose(false)}>{title}</DialogTitleWithX>
      <DialogContent sx={{ mt: 2 }}>
        <Typography component="div" whiteSpace="pre-line" variant="body1">
          {prompt}
        </Typography>
      </DialogContent>
      <DialogActions>
        {cancelText && (
          <Button
            variant="outlined"
            onClick={() => handleClose(false)}
            data-cy={`confirmation-${dialogId}-cancel`}
          >
            {cancelText}
          </Button>
        )}
        <Button
          variant="contained"
          color={okColor}
          autoFocus={autoFocus}
          onClick={() => handleClose(true)}
          data-cy={`confirmation-${dialogId}-ok`}
        >
          {okText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationDialog;
